/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
/* eslint-disable react/jsx-no-bind */
// eslint-disable-next-line react/jsx-no-bind
import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'

import ModalImage1 from 'img/kokall-zomer-1.png'
import ModalImage2 from 'img/kokall-zomer-2.png'
import ModalImageMobile1 from 'img/kokall-mobiel-zomer-1.png'
import ModalImageMobile2 from 'img/kokall-zomer-mobiel-2.png'
import styled from 'styled-components'

const MODAL_IMAGE_SWITCH_DATE = new Date('2026-08-08T00:00:00')

function getModalImage(isMobile: boolean) {
  const useImage2 = Date.now() >= MODAL_IMAGE_SWITCH_DATE.getTime()

  if (isMobile) {
    return useImage2 ? ModalImageMobile2 : ModalImageMobile1
  }

  return useImage2 ? ModalImage2 : ModalImage1
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
  },
}

function Popup() {
  const [modalIsOpen, setIsOpen] = useState(false)
  useEffect(() => {
    setTimeout(() => {
      {
        !sessionStorage.getItem('hide2') && setIsOpen(true)
      }
    }, 2000)
  }, [])

  function closeModal() {
    sessionStorage.setItem('hide2', 'true')
    setIsOpen(false)
  }

  const DesktopImg = styled.img`
    width: 850px;
    height: auto;

    @media (max-width: 991px) {
      display: none;
    }
  `

  const MobileImg = styled.img`
    display: none;

    @media (max-width: 991px) {
      display: block;
    }
  `

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="position-relative">
          <div
            className="position-absolute"
            style={{ right: '.5rem', top: '.5rem' }}
          >
            <button type="button" onClick={closeModal}>
              x
            </button>
          </div>
          <div onClick={closeModal} role="button">
            <a href="/showroom">
              <DesktopImg
                src={getModalImage(false)}
                width={850}
                height="auto"
                alt="Weru"
              />
              <MobileImg
                src={getModalImage(true)}
                width={350}
                height="auto"
                alt="Weru"
              />
            </a>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Popup
